/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.swatchHandler = {
  init: function($container) {

    // The swatches are <span>s with a click handler: no role, not focusable and
    // deaf to the keyboard, so Tab skipped straight past every size. Give them
    // button semantics here rather than in markup, because the same swatch
    // block is rendered by five different product-card snippets.
    $container.find('.spf-product__swatch').each(function() {
      const $swatch = $(this);

      // The "+4" overflow counter carries the same class as a real swatch but
      // selects nothing -- it has no data-option-value, and the click handler
      // below returns early without a title. Giving it role="button" told
      // screen readers it was actionable and put a dead stop in the tab order,
      // so it is left as the plain text it is.
      if ($swatch.hasClass('non-clickable-text') || !$swatch.attr('data-option-value')) {
        return;
      }

      $swatch.attr('role', 'button');
      $swatch.attr('tabindex', '0');
      $swatch.attr('aria-pressed', $swatch.hasClass('is-selected') ? 'true' : 'false');

      // A size that cannot be bought still needs to say so; the sold-out class
      // is otherwise conveyed by styling alone.
      if ($swatch.hasClass('sold-out')) {
        $swatch.attr('aria-disabled', 'true');
      }
    });

    // role="button" means Enter and Space must both activate. Delegating to
    // click keeps a single code path with the mouse behaviour below.
    $container.on('keydown', '.spf-product__swatch', function(e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        this.click();
      }
    });

    // Color swatch click handler
    $container.find('.spf-product__swatch').on('click', function(e) {
      const $swatch = $(this);

      // Size swatches (spf-product__swatchs round Size) are not color swatches — skip.
      const isSizeSwatch = $swatch.closest('.spf-product__swatchs.round.Size').length > 0;
      

      e.preventDefault();
      const colorTitle = $swatch.attr('title');
      
      if (!colorTitle) return;
      
      // Find the parent product card
      const $productCard = $swatch.closest('.gallery-cell, .thumbnail, .collection__item');
      
      // Update active state
      $swatch.siblings('.spf-product__swatch').removeClass('is-selected').attr('aria-pressed', 'false');
      $swatch.addClass('is-selected').attr('aria-pressed', 'true');
      
      // Size swatches don't map to a product image — skip the image swap.
      if (!isSizeSwatch) {
        // Find all images in this product card
        const $allImages = $productCard.find('.spf-product-card__image');

        // Find matching and non-matching images
        const $matchingImages = $allImages.filter(function() {
          return $(this).attr('data-variants') === colorTitle;
        });

        const $nonMatchingImages = $allImages.not($matchingImages);

        // Remove main/secondary classes from non-matching images and hide them
        $nonMatchingImages.removeClass('spf-product-card__image-main spf-product-card__image-secondary')
                          .addClass('spf-product-card__image-hidden');

        // Show matching images and set main/secondary classes
        $matchingImages.removeClass('spf-product-card__image-main spf-product-card__image-secondary');

        // If more than 2 matching images, only show first 2
        if ($matchingImages.length > 2) {
          $matchingImages.slice(0, 2).removeClass('spf-product-card__image-hidden');
          $matchingImages.slice(2).addClass('spf-product-card__image-hidden');
        } else {
          $matchingImages.removeClass('spf-product-card__image-hidden');
        }

        $matchingImages.eq(0).addClass('spf-product-card__image-main');
        if ($matchingImages.length > 1) {
          $matchingImages.eq(1).addClass('spf-product-card__image-secondary');
        }
      }

      // Build the full option selection (color + size + ...) from every swatch currently marked selected
      const selectedOptions = {};
      $productCard.find('.spf-product__swatch.is-selected').each(function() {
        const optionIndex = $(this).data('option');
        const optionValue = $(this).data('option-value');
        if (optionIndex !== undefined) selectedOptions[optionIndex] = optionValue;
      });

      const optionKeys = Object.keys(selectedOptions);
      const matchesSelection = (getOptionValue) =>
        optionKeys.every((key) => getOptionValue(key) === selectedOptions[key]);

      const $imageLink = $productCard.find('.spf-product-card__image-wrapper.hover-effect');
      const $variantSelect = $productCard.find('.spf-product__variants');
      const $priceWrapper = $productCard.find('.spf-product-card__price-wrapper-custom');

      const formatPrice = (cents) => {
        return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };

      // Apply the matched variant: update the image link href, the variant select, and the price
      const applyVariant = (variantId, price, compareAtPrice) => {
        if (variantId && $imageLink.length) {
          const baseHref = ($imageLink.attr('href') || '').split('?')[0];
          $imageLink.attr('href', baseHref + '?variant=' + variantId);
        }

        if (variantId && $variantSelect.length) {
          $variantSelect.val(String(variantId));
        }

        if (compareAtPrice && compareAtPrice > 0 && compareAtPrice > price) {
          $priceWrapper.html(
            '<span class="spf-product-card__oldprice money" tabindex="0">' + formatPrice(compareAtPrice) + '</span> ' +
            '<span class="spf-product-card__saleprice money" tabindex="0">' + formatPrice(price) + '</span>'
          );
        } else {
          $priceWrapper.html(
            '<span class="spf-product-card__price money" tabindex="0">' + formatPrice(price) + '</span>'
          );
        }
      };

      // Update prices, variant link and select based on the selected options
      const $variantDataScript = $productCard.find('.spf-product__variants-json');

      if ($variantDataScript.length) {
        // Use JSON data if available
        try {
          const variantData = JSON.parse($variantDataScript.text());

          const matchingVariant = variantData.variants.find((v) =>
            matchesSelection((key) => v['option' + key])
          );

          if (matchingVariant) {
            applyVariant(matchingVariant.id, matchingVariant.price, matchingVariant.compare_at_price);
          } else {
            console.warn('No matching variant found for selection:', selectedOptions);
          }
        } catch (error) {
          console.error('Error parsing variant JSON:', error);
        }
      } else {
        // Fallback to select options method
        const $matchingOption = $variantSelect.find('option').filter(function() {
          const $option = $(this);
          return matchesSelection((key) => $option.data('option' + key));
        }).first();

        if ($matchingOption.length) {
          applyVariant($matchingOption.val(), $matchingOption.data('price'), $matchingOption.data('compare_at_price'));
        }
      }
    });
  }
}

/******/ })();
